import gql from "graphql-tag"

export const fullUserList = gql`
  fragment fullUserList on UserList {
    limit
    count
    offset
    results {
      ...fullUser
    }
  }
`

const fragment = gql`
  fragment fullUser on User {
    uuid
    dateOfBirth {
      day
      month
      year
    }
    businessId
    email
    externalUserId
    externalStartDate
    firstName
    gender
    isEnabled
    isActivated
    lastName
    language
    metadata {
      createdAt
      createdBy
    }
    marketingEmailsAllowed
    phoneNumber
    profileImageUrl
    source
    teamIds
    isManagedExternally
    isGlobalAdmin
    regionId
    role
    primaryTeamId
    teamAssignments {
      teamId
      assignment
    }
    managedFields {
      managers
      fields {
        manager
        field
      }
    }
  }
`

export const toString = fragment.loc.source.body

export default fragment
